import { useTranslation } from 'react-i18next';
import { fmtDateTime, relTime } from '../lib/format';

/** Compact relative timestamp ("3 h ago") with the full value in the title attribute. */
export function RelativeTime({
  value: raw,
  className,
}: {
  value: Date | string | null | undefined;
  className?: string;
}) {
  const { t } = useTranslation();
  const value = raw instanceof Date ? raw.toISOString() : raw;
  if (!value) return <span className={className ?? 'bo-muted'}>—</span>;
  return (
    <span title={`${value} (${fmtDateTime(value)})`} className={className ? `bo-mono ${className}` : 'bo-mono'}>
      {relTime(value, t) ?? fmtDateTime(value)}
    </span>
  );
}
